export function buildTreeItems(root, filteredSet) {
  // filteredSet: Set de paths permitidos após busca/filtros
  function folderNode(folder) {
    const children = [];

    for (const sub of folder.folders || []) children.push(folderNode(sub));
    for (const f of folder.files || []) {
      if (filteredSet && !filteredSet.has(f.path)) continue;

      children.push({
        id: "file:" + encodeURIComponent(f.path),
        label: f.title || f.name,
        type: "file",
        filePath: f.path,
        meta: f,
      });
    }

    // se filtrado e pasta ficou vazia, não mostra
    if (filteredSet && children.length === 0) return null;

    return {
      id: "dir:" + folder.path,
      label: folder.name,
      type: "dir",
      children: children.filter(Boolean),
    };
  }

  const top = {
    id: "dir:root",
    label: "Conteúdo",
    type: "dir",
    children: [],
  };

  for (const sub of root.folders || []) {
    const n = folderNode(sub);
    if (n) top.children.push(n);
  }
  for (const f of root.files || []) {
    if (filteredSet && !filteredSet.has(f.path)) continue;
    top.children.push({
      id: "file:" + encodeURIComponent(f.path),
      label: f.title || f.name,
      type: "file",
      filePath: f.path,
      meta: f,
    });
  }

  return top;
}
